const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const OfficeModal = require("./OfficeModal");
const LoadingCircle = require("../../core/view/LoadingCircle");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const Bundles = require("../../core/Bundles");
const CopyTable = require("../data/CopyTable");
const AssetsUtil = require("../../core/util/AssetsUtil");
const Analytics = require("../../core/util/Analytics");
const StringUtil = require("../../../shared/StringUtil");

const styles = require("./styles/LoginModal.css");

/*
TODO: This and ChangePasswordModal have a lot in common.
They should perhaps share a component or subcomponents.
*/

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ChangeEmailModal",

		propTypes: {
			user: PT.object.isRequired,
			account: PT.object.isRequired,
			startOpen: PT.bool,
			cannotClose: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			beginChangeEmail: function(opts) {
				if (!this.state.isOpen) {
					this.openChangeEmail(opts);
				}
			},
			parentFormFail: function(error) {
				this.setState({
					isLoading: false,
					errorType: error,
				});
			},
			parentFormSuccess: function() {
				this.setState({
					isLoading: false,
					step: "confirmation",
					errorType: null,
				});
			},
		},

		getInitialState: function() {
			this.inputs = {};
			return {
				step: "changeEmail",
				isOpen: this.props.startOpen || false,
				newEmail: "",
				errorType: null,
				isLoading: false,
				forAccountPage: false,
			};
		},

		UNSAFE_componentWillReceiveProps: function(newProps) {
			if (newProps.startOpen && !this.state.isOpen) {
				this.openChangeEmail();
			}
		},

		openChangeEmail: function(opts = {}) {
			this.setState({
				step: "changeEmail",
				isOpen: true,
				newEmail: "",
				errorType: null,
				errorFields: [],
				isLoading: false,
				// Option to have "Save Changes" and "Cancel" buttons rather than Submit
				forAccountPage: opts.forAccountPage,
			});
		},

		onClose: function() {
			if (!this.props.cannotClose) {
				this.setState({isOpen: false});
			}
		},

		onChangeEmail: function() {
			const {user, account} = this.props;
			// No need to load the parent bundle if not already, so we'll do requireOpt
			// instead of requireOrLoadBundle.
			const OpsParentAcc = Bundles.requireOpt("parent", "OpsParentAcc");
			const contact =
				OpsParentAcc && OpsParentAcc.getFormSection(account, "contact");
			const accountEmail = contact && contact.email;

			if (!this.state.newEmail) {
				this.setState({
					errorType: "E_NEW_EMAIL_MISSING",
					errorFields: ["newEmail"],
				});
				this.focusInput("newEmail");
			} else if (!StringUtil.isValidEmail(this.state.newEmail)) {
				this.setState({
					errorType: "E_INVALID_NEW_EMAIL",
					errorFields: ["newEmail"],
				});
				this.focusInput("newEmail");
			} else if (
				this.state.newEmail === accountEmail &&
				!_.get(user, "model.newEmail")
			) {
				this.setState({
					errorType: "E_NO_CHANGE",
					errorFields: ["newEmail"],
				});
			} else {
				const vals = {email: this.state.newEmail};
				if (this.state.newEmail === _.get(user, "model.email")) {
					vals.newEmail = null;
				}
				this.props.dispatch({
					type: AT.SAVE_PARENT_FORM_REQUEST,
					section: "contact",
					vals,
				});
				this.setState({isLoading: true});
			}
		},

		handleKeyPress: function(evt, type) {
			if (evt.which === 13) {
				if (type === "newEmail") {
					this.onChangeEmail();
				}
			}
		},

		handleChange: function(evt, type) {
			const newState = {[type]: evt.target.value};
			if (this.state.errorType && _.includes(this.state.errorFields, type)) {
				newState.errorType = null;
				newState.errorFields = [];
			}
			this.setState(newState);
		},

		focusInput: function(type) {
			if (this.inputs[type]) {
				this.inputs[type].focus();
			}
		},

		renderInput: function(type, tabIndex) {
			const inputStyle =
				styles.input +
				(_.includes(this.state.errorFields, type) ? " " + styles.invalid : "");
			return (
				<input
					className={inputStyle}
					type={"email"}
					placeholder={CopyTable.getChangeEmailCopy()[type]}
					value={this.state[type]}
					onChange={evt => this.handleChange(evt, type)}
					onKeyPress={evt => this.handleKeyPress(evt, type)}
					ref={i => (this.inputs[type] = i)}
					tabIndex={tabIndex}
					{...Analytics.getHotjarSuppressionAttributes()}
				/>
			);
		},

		renderChangeContents: function() {
			return (
				<div className={styles.inputs}>{this.renderInput("newEmail", 51)}</div>
			);
		},

		renderConfirmation: function() {
			return (
				<img
					className={styles.successImg}
					src={AssetsUtil.getOfficeCharacter("happy-fiona-grok")}
				/>
			);
		},

		renderButtons: function(buttonAction, buttonText) {
			const {isLoading, forAccountPage, step} = this.state;
			if (forAccountPage && buttonText === "Submit") {
				//Switch default submit buttons to Save Changes with the button setting
				buttonText = "Save Changes";
			}
			const buttonClass = forAccountPage ? styles.twoButton : styles.button;
			let mainButton = (
				<div
					className={buttonClass}
					onClick={buttonAction}
					tabIndex={53}
					onKeyPress={evt => this.handleKeyPress(evt, "button")}
				>
					{buttonText}
				</div>
			);
			if (isLoading) {
				const loadingClass = forAccountPage
					? styles.twoLoadingContainer
					: styles.loadingContainer;
				mainButton = (
					<div className={loadingClass}>
						<div className={styles.loading}>
							<LoadingCircle colorType="white" />
						</div>
					</div>
				);
			}

			if (forAccountPage && step !== "confirmation") {
				//Return a row with the main button & a cancel button
				const cancelButton = (
					<div
						className={buttonClass}
						onClick={this.onClose}
						tabIndex={54}
						onKeyPress={evt => this.handleKeyPress(evt, "close")}
					>
						Cancel
					</div>
				);
				return (
					<div className={styles.twoButtonRow}>
						{mainButton}
						{cancelButton}
					</div>
				);
			} else {
				// Otherwise, just have the main button
				return mainButton;
			}
		},

		render: function() {
			const {isOpen, step, errorType, newEmail} = this.state;

			if (!isOpen) return null;

			const EmailCopy = CopyTable.getChangeEmailCopy(newEmail);
			//Decide the main contents of the step
			let contents = null;
			let buttonAction;
			let buttonText;
			let getErrorMessage;

			if (step === "changeEmail") {
				contents = this.renderChangeContents();
				buttonAction = this.onChangeEmail;
				buttonText = "Submit";
				getErrorMessage = CopyTable.forChangeEmailError;
			} else if (step === "confirmation") {
				contents = this.renderConfirmation();
				buttonAction = this.onClose;
				buttonText = "Okay";
			}

			let errorClass = styles.error;
			if (!errorType) errorClass += " " + styles.errorHidden;
			const changeBack = newEmail === _.get(this.props.user, "model.email");
			const belowContents =
				step === "confirmation" ? (
					<div className={styles.confirmText}>
						{changeBack
							? "Your email has been updated."
							: EmailCopy.confirmation}
					</div>
				) : (
					<div className={errorClass}>{getErrorMessage(errorType)}</div>
				);

			return (
				<OfficeModal
					onClose={this.onClose}
					closeOnEsc={true}
					portalContainer={null}
					level="overBar"
					modalClass={styles.main}
				>
					<div className={styles.container}>
						<div className={styles.aboveButton}>
							<div className={styles.title}>{EmailCopy.title}</div>
							<div className={styles.spacing} />
							{contents}
							{belowContents}
							<div className={styles.spacing} />
						</div>
						{this.renderButtons(buttonAction, buttonText)}
					</div>
				</OfficeModal>
			);
		},
	})
);
